import { CxEvent } from '@spartacus/core';

export class FbqGgOrderPlacedEvent extends CxEvent {
  event?: string;
  parameters?: {
    value?: number;
    currency?: string;
  };
}
